export default "__VITE_ASSET__DANUKXjh__"